import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { TextField, Button, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import AuthAlert from '../components/AuthAlert';
import AuthCard from '../components/AuthCard';
import PasswordField from '../components/PasswordField';
import { useColors } from '../context/ThemeContext';

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const colors = useColors();
  const [form, setForm] = useState({ login: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirect destination after login (e.g. ?redirect=/settings%23credits)
  const redirectTo = new URLSearchParams(location.search).get('redirect') || '/dashboard';

  useEffect(() => {
    if (user) navigate(redirectTo);
  }, [user, navigate, redirectTo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.login, form.password);
      navigate(redirectTo);
    } catch {
      setError('Email, nom d\'utilisateur ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Gérez vos déclarations musicales">
      <Typography variant="h6" sx={{ color: colors.textPrimary, textAlign: 'center' }}>Connexion</Typography>

      {error && <AuthAlert>{error}</AuthAlert>}

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <TextField label="Email ou nom d'utilisateur" required fullWidth autoFocus
          disabled={loading}
          value={form.login} onChange={(e) => setForm({ ...form, login: e.target.value })} />
        <PasswordField label="Mot de passe" required fullWidth
          disabled={loading}
          value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(e); }} />
        <Button type="submit" variant="contained" color="primary" fullWidth size="large"
          disabled={loading}
          sx={{ mt: 1, py: 1.5, fontSize: '1rem', fontWeight: 700 }}>
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Se connecter'}
        </Button>
      </form>

      <Typography textAlign="center" variant="body2" sx={{ color: colors.textSecondary }}>
        Pas de compte ?{' '}
        <Link to="/register" style={{ color: colors.primaryLight, fontWeight: 600, textDecoration: 'none' }}>
          S'inscrire
        </Link>
      </Typography>

      <Typography textAlign="center" variant="body2">
        <Link to="/forgot-password" style={{ color: colors.textSecondary, textDecoration: 'none' }}>
          Mot de passe oublié ?
        </Link>
      </Typography>

      <Typography textAlign="center" variant="body2">
        <Link to="/" style={{ color: colors.primaryLight, fontWeight: 600, textDecoration: 'none' }}>
          ← Retour à l'accueil
        </Link>
      </Typography>
    </AuthCard>
  );
}
